import ChannelManagement from './ChannelManagement';

export default ChannelManagement;
